import styled, { keyframes } from 'react-emotion'
import { space, themeGet as th } from 'styled-system'

const progressBarAnim = keyframes`
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
`

export default styled('div')`
  animation: ${progressBarAnim};
  animation-duration: ${props => props.duration}s;
  background-color: ${th('colors.groovy')};
  height: 9px;
  transform-origin: left center;
  width: 100%;

  ${space};
`
